import { render, staticRenderFns } from "./CreateBreed.vue?vue&type=template&id=4cec852c&scoped=true&"
import script from "./CreateBreed.vue?vue&type=script&lang=js&"
export * from "./CreateBreed.vue?vue&type=script&lang=js&"
import style0 from "./CreateBreed.vue?vue&type=style&index=0&id=4cec852c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cec852c",
  null
  
)

export default component.exports